import '@mantine/core/styles.layer.css'
import '@mantine/dropzone/styles.css'
import '@mantine/notifications/styles.css'
import 'mantine-datatable/styles.layer.css'
import './main.css'
import './sentry'

import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import { useAuth } from './auth-provider/auth-context'
import AuthProvider from './auth-provider/AuthProvider'
import { queryClient } from './queryClient'
// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { mantineTheme } from './theme'
import { useUser } from './user-provider/user-context'
import UserProvider from './user-provider/UserProvider'

// Create a new router instance
const router = createRouter({ routeTree, context: { auth: undefined, user: undefined } })

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Render the app
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <MantineProvider theme={mantineTheme}>
        <Notifications />
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <AuthProvider>
            <UserProvider>
              <InnerApp />
            </UserProvider>
          </AuthProvider>
        </QueryClientProvider>
      </MantineProvider>
    </StrictMode>,
  )
}

// export to allow fast refresh
export function InnerApp() {
  const auth = useAuth()
  const user = useUser()

  return <RouterProvider router={router} context={{ auth, user }} />
}
